/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';


export const birth : {[key: string]: Array<[string, string]>} = {
};
